import { registerModal } from 'features/Modal/ModalRegistry'
import PhoneSystemFormModal from './PhoneSystemFormModal'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'PHONE_SYSTEM_FORM_MODAL'
registerModal(modalType, PhoneSystemFormModal)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {
      fullScreen: true,
    },
  })



// WEBPACK FOOTER //
// ./src/features/PhoneSystem/PhoneSystemFormModal/PhoneSystemFormModal.action.js